import { render, staticRenderFns } from "./echarts.vue?vue&type=template&id=5f9a4a72&scoped=true"
import script from "./echarts.vue?vue&type=script&lang=js"
export * from "./echarts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9a4a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f9a4a72')) {
      api.createRecord('5f9a4a72', component.options)
    } else {
      api.reload('5f9a4a72', component.options)
    }
    module.hot.accept("./echarts.vue?vue&type=template&id=5f9a4a72&scoped=true", function () {
      api.rerender('5f9a4a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulkyExpress/oversizedDashboard/oversizeOrderDashboard/component/echarts.vue"
export default component.exports